exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ivu-table-body::-webkit-scrollbar {  \n     height: 20px!important;\n        /* background-color: #C1C1C1 !important; */\n}\n\n/* 设置滚动条滑块的样式 */\n.ivu-table-body::-webkit-scrollbar-thumb {\n  background: #C1C1C1 !important;\n}\n\n", ""]);

// exports
